import { put } from "redux-saga/effects";
import { initalMarkerConst } from "../../../helpers/initialMarker";
import { addMarkerFailure, addMarkerRequest } from "../actionCreaters";
import { InitalMarkerActionType } from "../types";

export function* initalMarkerSaga({ payload: { fieldId } }: InitalMarkerActionType) {
    try {
        yield put(
            addMarkerRequest({
                fieldId: fieldId,
                markerData: initalMarkerConst,
            }),
        );
    } catch (error) {
        yield put(addMarkerFailure({ fieldId }));
        // yield put(Handle Error);
    }
}
